import { green, red, orange, grey } from '@mui/material/colors';

export const getColor = (startTime?: number, endTime?: number, estimatedTime = 0) => {
    if (!startTime || !endTime) return grey[400];

    const _startTime = new Date(startTime);
    const _endTime = new Date(endTime);

    if (isNaN(_startTime.getTime()) || isNaN(_endTime.getTime())) return grey[400];

    const seconds = Math.abs(_endTime.getTime() - _startTime.getTime());
    const minutes = Math.round(seconds / 60000) || 1;

    if (minutes <= estimatedTime) {
        return green[500];
    } else if (minutes > 1.5 * estimatedTime) {
        return red[500];
    } else {
        return orange[500];
    }
}